import * as R from 'ramda'
import schemaAt from 'coact/utils/schema/schemaAt'

import schemaModule from '../../../../utils/schema/index.js'

import { dataAccess } from '../../../purchaseOrder/index.js'

// for populate schema
const orderSchema = R.pipe(
  R.dissocPath(['contents', 'items']),
  schemaModule.create,
)(dataAccess.schema)

const schema = R.pipe(
  R.assocPath(['contents', 'orderRef'], orderSchema),
  schemaModule.create,
)(schemaAt(['items', 0], dataAccess.schema)) // itemSchema

export default schema
